// SharedLensPowerCalculator.js
import React, { useState } from 'react';
const LensPowerCalculator = () => {
  const [focalLength, setFocalLength] = useState('');
  const [lensPower, setLensPower] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!focalLength) {
      setError('Harap masukkan panjang fokus (F)');
      setLensPower('');
      setExplanation('');
      return;
    }
    const focalLengthValue = parseFloat(focalLength);
    if (isNaN(focalLengthValue)) {
      setError('Harap masukkan nilai panjang fokus yang valid');
      setLensPower('');
      setExplanation('');
      return;
    }
    const lensPowerValue = 1 / focalLengthValue;
    setLensPower(lensPowerValue.toFixed(2));
    const lensType = lensPowerValue > 0 ? 'Lensa Cembung' : 'Lensa Cekung';
    setExplanation(
      `Kekuatan lensa (C) = 1 / panjang fokus (F) = 1 / ${focalLengthValue} = ${lensPowerValue.toFixed(2)}\n\n` +
      `Karena kekuatan lensa positif (+), jika ini adalah lensa ${lensType}.`
    );
    setError('');
  };
  return (
    <div >
      <div>
        <input
          type="number"
          placeholder="Panjang fokus (F)"
          value={focalLength}
          onChange={(e) => setFocalLength(e.target.value)}
          className="form-control"
          style={{ width: '75%' }}
        />
        <br/>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px' }}
          onClick={handleCalculate}
        >
          Hitung Kekuatan Lensa
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Kesalahan: {error}</p>
        ) : (
          <>
            {lensPower !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Kekuatan Lensa (C): {lensPower}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Langkah-langkah penyelesaian: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default LensPowerCalculator;